import React from 'react';
import Btn from '../../../../components/molecules/Btn';
import { Icons } from '../../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { daysAndMonthsWithLeadingZero, months } from './useCalendar';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type CalendarSelectDataType = {
  currentMonth: number;
  currentYear: number;
  tableId: string;
  currentMonthId: string;
  setPreviousMonthAndYear: () => void;
  setNextMonthAndYear: () => void;
  calendarRangeStart: Date;
  calendarRangeEnd: Date;
};
export function CalendarSelectData({
  currentMonth,
  currentYear,
  tableId,
  currentMonthId,
  setPreviousMonthAndYear,
  setNextMonthAndYear,
  calendarRangeStart,
  calendarRangeEnd,
}: CalendarSelectDataType) {
  const { t } = useSonTranslation('Calendar');

  const prevText = `${t(`months.${months[currentMonth === 1 ? 11 : currentMonth - 2]}`)} ${currentMonth === 1 ? currentYear - 1 : currentYear}`;

  const nextText = `${t(`months.${months[currentMonth === 12 ? 0 : currentMonth]}`)} ${currentMonth === 12 ? currentYear + 1 : currentYear}`;

  const rangeStart = new Date(calendarRangeStart);
  const rangeEnd = new Date(calendarRangeEnd);

  return (
    <div className="calendar__select-date">
      <div className="calendar__select-button">
        <Btn
          svgSpriteId={Icons.ARROW_LEFT}
          text={prevText}
          titleText={prevText}
          hiddenText
          tooltipPlacement={TooltipPlacement.TOP}
          onClick={setPreviousMonthAndYear}
          ariaControls={[tableId, currentMonthId]}
          disabled={rangeStart.getMonth() + 1 === currentMonth && rangeStart.getFullYear() === currentYear}
        />
      </div>
      <p className="calendar__selected-date font-bold-18-24" id={currentMonthId}>
        <time dateTime={`${currentYear}-${daysAndMonthsWithLeadingZero(currentMonth)}`}>
          {`${t(`months.${months[currentMonth - 1]}`)} ${currentYear}`}
        </time>
      </p>
      <div className="calendar__select-button">
        <Btn
          svgSpriteId={Icons.ARROW_RIGHT}
          text={nextText}
          titleText={nextText}
          hiddenText
          tooltipPlacement={TooltipPlacement.TOP}
          onClick={setNextMonthAndYear}
          ariaControls={[tableId, currentMonthId]}
          disabled={rangeEnd.getMonth() + 1 === currentMonth && rangeEnd.getFullYear() === currentYear}
        />
      </div>
    </div>
  );
}
